import React from 'react';
import { Link } from 'react-router-dom';
import { FaWhatsapp, FaTelegramPlane, FaInstagram, FaUsers } from 'react-icons/fa';
import Icon from '../AppIcon';
import {
  ROUTES,
  SITE,
  SOCIALS,
  WA_MESSAGES,
  WHATSAPP_DISPLAY,
  openTelegram,
  openWhatsApp,
} from '../../config/site';

const KEYWORD_CLUSTERS = [
  {
    title: 'Explore Nitin Online Book',
    links: ['Nitin Online Book', 'Nitin Online Book', 'Nitin Book', 'Nitin Betting Book'],
  },
  {
    title: 'Quick access',
    links: ['Nitin Online Book Login', 'Nitin Online Book Sign Up', 'Nitin Online Book App Download'],
  },
  {
    title: 'Learn more',
    links: ['Nitin Online Book App', 'Nitin Online Book India', 'Nitin Online Book Download', 'Nitin Online Book Review'],
  },
];

const QUICK_LINKS = [
  { label: 'Home', to: ROUTES.home },
  { label: 'Gaming Palace', to: ROUTES.games },
  { label: 'Winners Circle', to: ROUTES.winners },
  { label: 'Our Story', to: ROUTES.about },
  { label: 'VIP Contact Suite', to: ROUTES.contact },
];

const SERVICES = [
  { label: 'Nitin online book login', message: WA_MESSAGES.login },
  { label: 'Nitin online book sign up', message: WA_MESSAGES.newId },
  { label: 'Nitin online book app download', message: WA_MESSAGES.appDownload },
  { label: 'Deposit & instant withdrawal', message: WA_MESSAGES.withdrawal },
  { label: 'VIP limits & cashback', message: WA_MESSAGES.vip },
];

const Footer = () => (
  <footer className="relative overflow-hidden border-t border-white/10 bg-[#05050B]">
    <span className="aurora -left-24 top-0 h-72 w-72 bg-royal-gold/25" aria-hidden="true" />
    <span className="aurora -right-16 bottom-0 h-80 w-80 bg-royal-violet/30" aria-hidden="true" />

    <div className="relative mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
      {/* CTA band */}
      <div className="panel-gold shine-hover relative mb-14 overflow-hidden px-6 py-10 text-center sm:px-12">
        <span className="badge-pill mb-5">Official Portal</span>
        <h2 className="font-heading text-3xl font-bold text-white sm:text-4xl">
          Open your <span className="gold-text">Nitin Online Book</span> ID tonight
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-white/60">
          One WhatsApp message is all it takes. Our VIP desk handles sign up, login help, app download and your
          first withdrawal — verified, private and available 24×7.
        </p>
        <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <button onClick={() => openWhatsApp(WA_MESSAGES.newId)} className="btn-3d btn-3d-wa">
            <FaWhatsapp size={19} /> WhatsApp {WHATSAPP_DISPLAY}
          </button>
          <button onClick={openTelegram} className="btn-3d btn-3d-ghost">
            <FaTelegramPlane size={18} /> Join Telegram VIP
          </button>
        </div>
      </div>

      <div className="grid gap-10 lg:grid-cols-4">
        {/* Brand */}
        <div className="lg:col-span-1">
          <div className="flex items-center gap-3">
            <span className="flex h-12 w-12 items-center justify-center rounded-full border border-royal-gold/40 bg-[#0D0D17]">
              <img src="/assets/images/logo.png" alt="Nitin Online Book" className="h-9 w-9 rounded-full object-contain" />
            </span>
            <span>
              <span className="block font-heading text-lg font-bold gold-text">Nitin Online Book</span>
              <span className="text-[0.62rem] uppercase tracking-[0.22em] text-white/40">Nitin Online Book</span>
            </span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-white/55">
            {SITE.tagline}. Verified tables, bank-grade security and payouts that actually land in five minutes —
            backed by a support desk that answers like a human, because it is one.
          </p>
          <div className="mt-5 flex flex-wrap gap-3">
            <button
              onClick={() => openWhatsApp(WA_MESSAGES.general)}
              aria-label="WhatsApp"
              className="flex h-11 w-11 items-center justify-center rounded-full border border-wa-green/40 bg-wa-green/10 text-wa-green transition hover:-translate-y-1 hover:bg-wa-green hover:text-white"
            >
              <FaWhatsapp size={19} />
            </button>
            <a
              href={SOCIALS.telegramChannel}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Telegram channel"
              className="flex h-11 w-11 items-center justify-center rounded-full border border-trust-blue/40 bg-trust-blue/10 text-trust-blue transition hover:-translate-y-1 hover:bg-trust-blue hover:text-white"
            >
              <FaTelegramPlane size={18} />
            </a>
            <a
              href={SOCIALS.telegramGroup}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Telegram community group"
              className="flex h-11 w-11 items-center justify-center rounded-full border border-trust-blue/30 bg-trust-blue/8 text-trust-blue/90 transition hover:-translate-y-1 hover:bg-trust-blue hover:text-white"
            >
              <FaUsers size={17} />
            </a>
            <a
              href={SOCIALS.instagram}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="flex h-11 w-11 items-center justify-center rounded-full border border-victory-red/40 bg-victory-red/10 text-victory-red transition hover:-translate-y-1 hover:bg-gradient-to-br hover:from-[#F58529] hover:via-[#DD2A7B] hover:to-[#8134AF] hover:text-white"
            >
              <FaInstagram size={19} />
            </a>
          </div>
        </div>

        {/* Links */}
        <div>
          <h3 className="mb-4 font-display text-sm font-semibold uppercase tracking-[0.18em] text-royal-gold">
            Explore
          </h3>
          <ul className="space-y-2.5">
            {QUICK_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="group inline-flex items-center gap-2 text-sm text-white/60 transition hover:text-white">
                  <Icon name="ChevronRight" size={14} className="text-royal-gold transition group-hover:translate-x-1" />
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div>
          <h3 className="mb-4 font-display text-sm font-semibold uppercase tracking-[0.18em] text-royal-gold">
            Player Services
          </h3>
          <ul className="space-y-2.5">
            {SERVICES.map((s) => (
              <li key={s.label}>
                <button
                  onClick={() => openWhatsApp(s.message)}
                  className="group inline-flex items-center gap-2 text-left text-sm text-white/60 transition hover:text-white"
                >
                  <Icon name="MessageCircle" size={14} className="text-wa-green" />
                  {s.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h3 className="mb-4 font-display text-sm font-semibold uppercase tracking-[0.18em] text-royal-gold">
            Reach the VIP desk
          </h3>
          <div className="card-flat space-y-3 p-5">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-wa-green/15 text-wa-green">
                <FaWhatsapp size={18} />
              </span>
              <div>
                <p className="text-xs text-white/45">WhatsApp · 24×7</p>
                <p className="font-display text-sm font-semibold text-white">{WHATSAPP_DISPLAY}</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-royal-gold/15 text-royal-gold">
                <Icon name="Globe" size={18} />
              </span>
              <div>
                <p className="text-xs text-white/45">Official website</p>
                <p className="font-display text-sm font-semibold text-white">{SITE.domain}</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-trust-blue/15 text-trust-blue">
                <Icon name="Mail" size={18} />
              </span>
              <div className="min-w-0">
                <p className="text-xs text-white/45">Email · {SOCIALS.city}</p>
                <p className="truncate font-display text-sm font-semibold text-white">{SOCIALS.email}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Keyword clusters */}
      <div className="divider-glow my-10" />
      <div className="grid gap-8 sm:grid-cols-3">
        {KEYWORD_CLUSTERS.map((cluster) => (
          <div key={cluster.title}>
            <h4 className="mb-3 font-display text-xs font-semibold uppercase tracking-[0.18em] text-white/45">
              {cluster.title}
            </h4>
            <ul className="space-y-1.5">
              {cluster.links.map((l) => (
                <li key={l}>
                  <Link to={ROUTES.home} className="text-sm text-white/50 transition hover:text-royal-gold">
                    {l}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* SEO paragraph — keyword rich, human readable */}
      <div className="divider-glow my-10" />
      <p className="text-xs leading-relaxed text-white/35">
        {SITE.name} is the official {SITE.altName} portal on {SITE.domain}. Players across India come here for
        Nitin online book login, Nitin online book sign up, Nitin online book app download, live Teen Patti, Andar
        Bahar, Dragon Tiger, roulette, cricket and football books, secure gaming India wide, and the fastest
        instant payouts backed by 24/7 WhatsApp support. Gaming involves financial risk — play responsibly, set
        your limits, and never bet more than you can comfortably afford. 18+ only.
      </p>

      <div className="mt-8 flex flex-col items-center justify-between gap-4 sm:flex-row">
        <p className="text-xs text-white/40">
          © {new Date().getFullYear()} {SITE.name}. All rights reserved.
        </p>
        <div className="flex items-center gap-4 text-xs text-white/40">
          <span className="inline-flex items-center gap-1.5"><Icon name="ShieldCheck" size={13} className="text-wa-green" /> SSL secured</span>
          <span className="inline-flex items-center gap-1.5"><Icon name="BadgeCheck" size={13} className="text-royal-gold" /> Fair play certified</span>
          <span className="inline-flex items-center gap-1.5"><Icon name="Heart" size={13} className="text-victory-red" /> 18+ responsible gaming</span>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
